import * as React from 'react'

import * as S from '../styles'

import { useTransition } from '../behaviours'
import * as glyphs from '../icons/glyphs/stroke'

export type DrawerProps = {
  children: React.ReactNode
  className?: string
  displayCloseButton?: boolean
  isOpen: boolean
  onClose?: () => void
  padding?: React.CSSProperties['padding']
  width?: React.CSSProperties['width']
  lockedScroll?: boolean
  noOverlay?: boolean
}

export function Drawer({
  children,
  className,
  displayCloseButton = true,
  isOpen = false,
  onClose = () => {},
  width = '489px',
  padding,
  lockedScroll = false,
  noOverlay = false,
}: DrawerProps): React.ReactElement | null {
  const { step, unmounted } = useTransition(isOpen)

  if (unmounted) {
    return null
  }

  return (
    <>
      {!noOverlay && <S.drawer.Overlay onClick={onClose} open={isOpen} step={step} />}
      <S.drawer.Panel width={width} padding={padding} step={step} className={className} $lockedScroll={lockedScroll}>
        <S.drawer.ContentWrapper>
          {displayCloseButton && (
            <S.drawer.CloseButton onClick={onClose}>
              <glyphs.Close size={16} />
            </S.drawer.CloseButton>
          )}
          {children}
        </S.drawer.ContentWrapper>
      </S.drawer.Panel>
    </>
  )
}
